<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="6" sm="6">
          <v-text-field
            :error-messages="nameErrors"
            :label="$t('name')"
            @blur="$v.item.name.$touch()"
            @input="$v.item.name.$touch()"
            v-model="item.name"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" sm="6">
          <v-text-field
            :error-messages="textErrors"
            :label="$t('text')"
            @blur="$v.item.text.$touch()"
            @input="$v.item.text.$touch()"
            v-model="item.text"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import has from "lodash/has";
import { required } from "vuelidate/lib/validators";

export default {
  name: "PaymentMethodForm",
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {},
    },

    loading: {
      type: Boolean,
      required: true,
    },

    initialValues: {
      type: Object,
      default: () => {},
    },

    handleSubmit: {
      type: Function,
      required: false,
    },

    handleReset: {
      type: Function,
      required: false,
    },
  },
  mounted() {},
  data() {
    return {
      name: null,
      text: null,
    };
  },
  computed: {
    item() {
      return this.initialValues || this.values;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.item.name.$dirty) {
        return errors;
      }
      has(this.violations, "name") && errors.push(this.violations.name);
      !this.$v.item.name.required && errors.push(this.$t("Field is required"));

      return errors;
    },
    textErrors() {
      const errors = [];
      if (!this.$v.item.text.$dirty) {
        return errors;
      }
      has(this.violations, "text") && errors.push(this.violations.text);
      !this.$v.item.text.required && errors.push(this.$t("Field is required"));
      return errors;
    },
    violations() {
      return this.errors || {};
    },
  },
  methods: {
    submitItem() {
      if (this.handleSubmit) {
        this.handleSubmit();
      }
    },
    resetItem() {
      if (this.handleReset) {
        this.handleReset();
      }
    },
  },
  validations: {
    item: {
      name: {
        required,
      },
      text: {
        required,
      },
    },
  },
};
</script>
